import React, { useRef } from 'react';
import { Marker, Popup, Tooltip } from 'react-leaflet';

export default function HoverMarker(props) {
  const {
    position, text, icon, onClick,
  } = props;
  const markerRef = useRef(null);

  return (
    <Marker
      icon={icon}
      position={position}
      eventHandlers={{
        click: onClick,
        mouseover: () => markerRef.current?.openPopup(),
        mouseout: () => markerRef.current?.closePopup(),
      }}
    >
      <Tooltip direction="left" offset={[10, -10]} opacity={1}>{text}</Tooltip>
    </Marker>
  );
}
